<div class="card_box">
  <button aria-label="close" class="close-btn" mat-dialog-close>
    <app-svg-icon class="ico_close" icon="close"></app-svg-icon>
    Close
  </button>

  <div class="card_box_title">
    <app-svg-icon icon="course_locked"></app-svg-icon>
    <h3>Upgrade to Unlock Case Study Challenges</h3>
  </div>

  <div class="items row">
    <div class="item col-12">
      <p class="card_box_text">
        Test your skills and knowledge by completing on-the-job tasks using real-world scenarios, exclusively available for Self-Study and
        Full-Immersion learners.
      </p>
      <p class="card_box_text">Upgrade now to get access.</p>
    </div>
    <div class="item col-12">
      <div class="buttons">
        <a [href]="'https://corporatefinanceinstitute.com/upgrade/'" class="button" target="_blank" mat-dialog-close>
          <span class="wrapping-content">
            <span class="before">Upgrade Now</span>
            <span class="after">Upgrade Now</span>
          </span>
        </a>
      </div>
    </div>
  </div>
</div>
